import Field from './Field.vue';
import FieldGroup from './FieldGroup.vue';

/** @deprecated Use `SphFormField` from `@/components/base/form-field`. */
const SphField = Field;

/** @deprecated Use `SphFieldset`, or `SphFormRow` for fields side by side, from `@/components/base/form-field`. */
const SphFieldGroup = FieldGroup;

export { SphField, SphFieldGroup };

export default SphField;
